export enum SelfServiceSlotStatus {
  ASSIGNED = 'ASSIGNED',
  PRE_UNASSIGNED = 'PRE_UNASSIGNED',
  UNASSIGNED = 'UNASSIGNED',
}

/** Minimal slot identity shared by every projection (mirrors the backend `SlotData`). */
export interface SlotData {
  position: number;
  rack: number;
}

/**
 * Full kiosk slot entity held in the store (mirrors the backend `AdminSlot`, returned by `getKioskData`).
 * `status`/`finalized` describe the slot ↔ self-service assignment and are only provided by
 * `getKioskData`; partial sources (`openSlot`, `getSelfServiceById`) don't carry them — hence optional.
 */
export interface AdminSlot extends SlotData {
  id: string;
  used: boolean;
  lastName?: string;
  firstName?: string;
  finalized?: boolean;
  displayName?: string;
  referenceId?: string;
  registration?: string;
  selfServiceId?: string;
  selfServiceType?: string;
  status?: SelfServiceSlotStatus;
}
